import { BaseApiService } from '@services/baseApiService';
import { AssetTypeOutputDTO } from '@features/assetType/types';

export class AssetTypeService extends BaseApiService<AssetTypeOutputDTO> {
  constructor() {
    super('assettypes');
  }

  // Você pode adicionar métodos específicos para AssetType aqui, se necessário
}

export const assetTypeService = new AssetTypeService(); 